import React, { useEffect, useState } from "react";
import { IconContext } from "react-icons";
import { Link } from "react-router-dom";
import { NavDetails as details } from "./NavDetails";
import * as FaIcons from "react-icons/fa";
import * as BsIcons from "react-icons/bs";
import jwt_decode from "jwt-decode";
import "./Navbar.css";

export default function Navbar() {
  const token = sessionStorage.getItem("token");

  const [sidebar, setSidebar] = useState(false);

  const showSidebar = () => setSidebar(!sidebar);
  const isLoggedInTag8SuperAdmin =
    sessionStorage.getItem("token") &&
    sessionStorage.getItem("role") === "tag8superadmin";

  const handleLogout = () => {
    sessionStorage.clear();
    window.location = "/";
  };

  useEffect(() => {
    // console.log("token: ", token);
    if (token) {
      setInterval(() => {
        const decoded = jwt_decode(token);
        const expiry = decoded.exp * 1000 - 60000;
        // console.log("expiry: ", expiry);
        // console.log("current Time: ", Date.now());
        if (Date.now() >= expiry) {
          handleLogout();
        }
      }, 1000);
    }
  });

  return (
    <>
      <IconContext.Provider value={{ color: "#8A8E84" }}>
        <div className="navbar">
          {token !== null ? (
            <Link to="#" className="menu-bars">
              <BsIcons.BsChevronBarRight
                color={`${isLoggedInTag8SuperAdmin ? "#f9bd33" : ""}`}
                onClick={showSidebar}
              />
            </Link>
          ) : (
            " "
          )}

          <Link to="/trip" className="logo menu-bars ">
            <p>Tag8 RTLS</p>
          </Link>
        </div>

        {token !== null ? (
          <nav className={sidebar ? "nav-menu active" : "nav-menu"}>
            <ul className="nav-menu-items" onClick={showSidebar}>
              <li className="navbar-toggle">
                <Link to="#" className="menu-bars">
                  <BsIcons.BsChevronBarLeft
                    color={`${isLoggedInTag8SuperAdmin ? "#f9bd33" : ""}`}
                  />
                </Link>
              </li>

              {/* nav-text */}
              {details.map((item, index) => {
                return (
                  <li key={index} className={item.cName}>
                    <Link to={item.path}>
                      <span className="nav-text-icon">{item.icon}</span>

                      <span className="nav-text-title">{item.title}</span>
                    </Link>
                  </li>
                );
              })}

              <div className="logout-container">
                <button className="logout-button" onClick={handleLogout}>
                  <FaIcons.FaSignOutAlt />
                  Logout
                </button>
              </div>
            </ul>
          </nav>
        ) : (
          " "
        )}
      </IconContext.Provider>
    </>
  );
}
